import { useAuth0 } from "@auth0/auth0-react"
import { useMemo } from "react"
import {
  download,
  jsonGet,
  jsonPatch,
  jsonPut,
  jsonPost,
  jsonDelete,
  uploadFile,
  ApiType,
  DownloadResponse,
  Headers,
  formDataPost
} from "src/services/api"

export const useApi = (api: ApiType) => {
  const { getAccessTokenSilently } = useAuth0()
  return useMemo(
    () => ({
      download: async (
        uri: string,
        options?: { headers?: Headers; signal?: AbortSignal }
      ): Promise<DownloadResponse> => download(uri, await getAccessTokenSilently(), api, options),
      formDataPost: async <TData>(uri: string, body: FormData, headers = {}) =>
        formDataPost<TData>(uri, body, await getAccessTokenSilently(), headers, api),
      jsonDelete: async (uri: string, headers = {}) =>
        jsonDelete(uri, await getAccessTokenSilently(), headers, api),
      jsonGet: async <TData>(uri: string, options?: { headers?: Headers; signal?: AbortSignal }) =>
        jsonGet<TData>(uri, await getAccessTokenSilently(), api, options),
      jsonPatch: async <TData>(uri: string, body: {}, headers = {}) =>
        jsonPatch<TData>(uri, body, await getAccessTokenSilently(), headers, api),
      jsonPost: async <TData>(uri: string, body: {}, headers = {}) =>
        jsonPost<TData>(uri, body, await getAccessTokenSilently(), headers, api),
      jsonPut: async <TData>(uri: string, body: {}, headers = {}) =>
        jsonPut<TData>(uri, body, await getAccessTokenSilently(), headers, api),
      uploadFile: async <TData>(
        uri: string,
        file: Blob,
        onProgress: (progressRate: number) => void
      ) => uploadFile<TData>(uri, file, await getAccessTokenSilently(), onProgress)
    }),
    [api, getAccessTokenSilently]
  )
}
